// extracted by mini-css-extract-plugin
export var content = "_oi-1";
export var noScroll = "_oi-3";
export var paper = "_oi-0";
export var scrollable = "_oi-2";